module.exports = __webpack_public_path__ + "media/images/athletes/3430-946cc636643c03716acc87459c0df00c.png";